import { ApiError } from '../api/client';
export interface FundingStatus {
  unresolvedDeposit?: {id:string;state:string;amount:number|null}|null;
  pendingResume?: {id:string;depositState:string;phase:string}|null;
}
export function fundingNotice(status:FundingStatus|undefined):string|null {
  if(status?.unresolvedDeposit)return 'Есть незавершённое пополнение кампании. Повтор заблокирован до проверки прежней операции.';
  if(status?.pendingResume)return status.pendingResume.depositState==='confirmed'
    ? 'Пополнение подтверждено. Автоматическое возобновление ожидает проверки статуса WB, расписания и ограничений.'
    : 'Подтверждение пополнения ещё не получено. Автоматический запуск пока не отправляется.';
  return null;
}
/** A transport/server failure cannot establish whether a cash request reached WB. */
export function unknownFundingError(error:unknown):boolean {
  return !(error instanceof ApiError&&error.status>=400&&error.status<500&&error.status!==408);
}
